import React, { useState, useEffect } from "react";
import { Tab, Tabs } from "react-bootstrap";
import ActivecadsClient from "./ActivecadsClient";
import { jobService } from "services/job.service";
import useCurrentUser from "hooks/useCurrentUser";

const JobTabComponent = ({ data, setData }) => {
  const [activeTab, setActiveTab] = useState("Pending");

  const [show, setShow] = useState(false)
  const handleShow = () => {
    setShow(true);
  }
  const handleClose = () => {
    setShow(false)
  }
  const { user } = useCurrentUser();
  const [dataLength, setDataLength] = useState({
    skip: 0,
    limit: 9
  })

  const handleTabSelect = (tab) => {
    setActiveTab(tab);
    setDataLength({
      skip: 0,
      limit: 9
    })

  };

  const handleClick = (event) => {
    event.stopPropagation();
  };

  const ClientJobs = async (values) => {

    try {
      const response = await jobService.clientJob(values);
      setData(response?.data?.data)
    } catch (err) {
      console.error(err?.response?.data?.message);
    }
  }

  const PilotJobs = async (values) => {
    try {
      const response = await jobService.getPilotJobs(values);

      setData(response?.data?.data)
      if (response?.data?.data?.success === 'false') {
        return "folder deleted"
      }
    } catch (err) {
      console.error(err?.response?.data?.message);
    }
  }

  useEffect(() => {
    const payload = {
      status: activeTab,
      ...dataLength
    }
    user?.roleType === 'PILOT' ? PilotJobs(payload) : ClientJobs(payload);
  }, [activeTab, dataLength])

  useEffect(() => {
    if (user?.roleType === "PILOT") {
      setActiveTab('InProgress')
    }
  }, [user])


  const handleViewMore = () => {
    const data = dataLength;
    setDataLength({
      ...data,
      limit: data?.limit + 9
    })
  }

  return (
    <div onClick={handleClick}  >
      <Tabs activeKey={activeTab} onSelect={handleTabSelect}>
        {user?.roleType === "CLIENT" && (
          <Tab eventKey="Pending" title="Active" className="p-0">
            <div>
              <ActivecadsClient setActiveTab={setActiveTab} data={data} setData={setData} handleViewMore={handleViewMore} activeTab={activeTab} />
            </div>
          </Tab>
        )}
        <Tab eventKey="InProgress" title="In Progress">
          <div>
            {/* <InProgressCards data={data} setData={setData} /> */}
            <ActivecadsClient setActiveTab={setActiveTab} data={data} setData={setData} handleViewMore={handleViewMore} />
          </div>
        </Tab>
        <Tab eventKey="Completed" title="Completed">
          <div>
            {/* <Compltedcards /> */}
            <ActivecadsClient setActiveTab={setActiveTab} data={data} setData={setData} handleViewMore={handleViewMore} />
          </div>
        </Tab>
      </Tabs>
    </div>
  );
};

export default JobTabComponent;
